import React from "react";
import check from "../../icons/icon_check.svg";
import AboutImgTwo from "../../images/about/about-img-two.svg";
const AboutSolution = () => {
  return (
    <section className="problem_solution_section section_space pb-0">
      <div className="container">
        <div
          className="ico_heading_block text-center"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center">
              <h2 className="heading_text mb-0">What Makes Us Different?</h2>
              
            </div>
          </div>
        </div>

        <div
          className="ico_problem_solution_table mb-3"
          data-aos="fade-up"
          data-aos-duration="600"
          data-aos-delay="100"
        >
          <div className="column_wrapper align-items-center">
            {/* ICO Problem Section */}
            <div className="column_problem">
              {/* <h3 className="heading_text mb-4">
                <span className="icon">
                  <img src={sIcon1} alt="Icon Man With Question" />
                </span> 
                <span className="text text-dark">For Customers</span>
              </h3> */}
              <ul className="iconlist_block unordered_list_block">
                {[
                  {
                    label:
                      "Not a cryptocurrency",
                  },
                  {
                    label:
                      "Not an investment or gambling system",
                  },
                  {
                    label:
                      "No risk, just rewards",
                  },
                  {
                    label: "Real cash unlocks through wallet milestones",
                  },
                   {
                    label: "Shops benefit from passive earnings across the network.",
                  },
                    {
                    label: "Designed for long-term loyalty and smarter local advertising",
                  },
                  
                ].map((item, index) => (
                  <li key={index}>
                    <span className="iconlist_icon">
                      <img src={check} alt="Icon Check" />
                    </span>
                    <span className="iconlist_label">
                      {item.label}
                      {/* <small className="iconlist_info">{item.info}</small> */}
                    </span>
                  </li>
                ))}
              </ul>
          
            </div>

            {/* ICO Solution Section */}
            <div className="column_solution justify-content-center text-center">
              <div className="row align-items-center justify-content-center">
             
                 <div className="column_problem p-5">
                  <img src={AboutImgTwo} className="img-fluid" alt=""/>
           
            </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
             <p>
                Every time a customer shops at any participating business, both the customer and the shop owner benefit. It’s a system built on fairness, innovation, and real world value perfect for businesses that want to stand out and customers who want to earn more.
              </p>
              <p>Whether you’re a business looking to grow, or a customer ready to start earning, TopCoin UK is the future of reward-based loyalty.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSolution;
